import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

interface ReplacementCharacterFormDialogProps {
  open: boolean;
  isEditMode: boolean;
  value: string;
  replacement: string;
  onClose: () => void;
  onValueChange: (value: string) => void;
  onReplacementChange: (value: string) => void;
  onSave: () => void;
}

const ReplacementCharacterFormDialog = ({
  open,
  isEditMode,
  value,
  replacement,
  onClose,
  onValueChange,
  onReplacementChange,
  onSave,
}: ReplacementCharacterFormDialogProps) => {
  const handleValueChange = (input: string) => {
    // Only allow single character
    if (input.length <= 1) {
      onValueChange(input);
    }
  };

  const handleReplacementChange = (input: string) => {
    // Only allow single character
    if (input.length <= 1) {
      onReplacementChange(input);
    }
  };

  const isSaveDisabled = value.length !== 1 || replacement.length !== 1;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isEditMode
          ? "Edit Replacement Character"
          : "Add New Replacement Character"}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus={!isEditMode}
          margin="dense"
          label="Value"
          fullWidth
          value={value}
          onChange={(e) => handleValueChange(e.target.value)}
          placeholder="e.g., E"
          disabled={isEditMode}
          slotProps={{ htmlInput: { maxLength: 1 } }}
          helperText="Enter a single character"
          sx={{ mb: 2 }}
        />
        <TextField
          autoFocus={isEditMode}
          margin="dense"
          label="Replacement Value"
          fullWidth
          value={replacement}
          onChange={(e) => handleReplacementChange(e.target.value)}
          placeholder="e.g., -"
          slotProps={{ htmlInput: { maxLength: 1 } }}
          helperText="Enter a single character"
          onKeyDown={(e) => {
            if (e.key === "Enter" && !isSaveDisabled) {
              onSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onSave} variant="contained" disabled={isSaveDisabled}>
          {isEditMode ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReplacementCharacterFormDialog;
